<template>
    <a-layout id="home">
<!--        <a-layout-sider :style="{ overflow: 'auto', height: '100vh', position: 'fixed', left: 0 }" v-model="collapsed" :trigger="null" collapsible>-->
        <a-layout-sider :style="{minHeight: '100vh'}" v-model="collapsed" :trigger="null" collapsible>
            <div class="logo">
                <h1 class="logo-h">管理后台</h1>
            </div>
            <a-menu theme="dark" mode="inline" :default-selected-keys="['/admin/member']" :selectedKeys="[$route.path]">

                <a-menu-item key="/admin/home">
                    <router-link to="/admin/home">
                        <a-icon type="bar-chart"/>
                        <span class="nav-text">后台首页</span>
                    </router-link>
                </a-menu-item>
                <a-menu-item key="/admin/member">
                    <router-link to="/admin/member">
                        <a-icon type="team"/>
                        <span class="nav-text">账号管理</span>
                    </router-link>
                </a-menu-item>
                <a-menu-item key="/admin/website">
                    <router-link to="/admin/website">
                        <a-icon type="google"/>
                        <span class="nav-text">站群管理</span>
                    </router-link>
                </a-menu-item>
                <a-menu-item key="/admin/urlRewrite">
                    <router-link to="/admin/urlRewrite">
                        <a-icon type="swap"/>
                        <span class="nav-text">URL映射</span>
                    </router-link>
                </a-menu-item>
                <a-menu-item key="/admin/articleBot">
                    <router-link to="/admin/articleBot">
                        <a-icon type="api" />
                        <span class="nav-text">SEO BOT</span>
                    </router-link>
                </a-menu-item>
                <a-sub-menu key="/admin/pro">
                    <span slot="title"><a-icon type="table" /><span>产品管理</span></span>
                    <a-menu-item key="/admin/proCategory">
                        <router-link to="/admin/proCategory">
                            <a-icon type="tags"/>
                            <span class="nav-text">产品分类</span>
                        </router-link>
                    </a-menu-item>
                    <a-menu-item key="/admin/pro">
                        <router-link to="/admin/pro">
                            <a-icon type="menu"/>
                            <span class="nav-text">产品列表</span>
                        </router-link>
                    </a-menu-item>
                </a-sub-menu>
                <a-sub-menu key="/admin/img">
                    <span slot="title"><a-icon type="camera" /><span>图片管理</span></span>
                    <a-menu-item key="/admin/imgTag">
                        <router-link to="/admin/imgTag">
                            <a-icon type="tags"/>
                            <span class="nav-text">图片标签</span>
                        </router-link>
                    </a-menu-item>
                    <a-menu-item key="/admin/img">
                        <router-link to="/admin/img">
                            <a-icon type="menu"/>
                            <span class="nav-text">图片列表</span>
                        </router-link>
                    </a-menu-item>
                </a-sub-menu>
                <a-sub-menu key="/admin/article">
                    <span slot="title"><a-icon type="edit" /><span>文章管理</span></span>
                    <a-menu-item key="/admin/articleTag">
                        <router-link to="/admin/articleTag">
                            <a-icon type="tags"/>
                            <span class="nav-text">文章标签</span>
                        </router-link>
                    </a-menu-item>
                    <a-menu-item key="/admin/article">
                        <router-link to="/admin/article">
                            <a-icon type="menu"/>
                            <span class="nav-text">文章列表</span>
                        </router-link>
                    </a-menu-item>
                </a-sub-menu>
            </a-menu>
        </a-layout-sider>
<!--        <a-layout :style="{ marginLeft: '200px' }">-->
        <a-layout>
            <a-layout-header :style="{ background: '#fff', padding: 0 }">
                <a-icon
                    class="trigger"
                    :type="collapsed ? 'menu-unfold' : 'menu-fold'"
                    @click="() => (collapsed = !collapsed)"
                />
            </a-layout-header>
            <a-layout-content :style="{ margin: '24px 16px 0', minHeight: '280px' }">
                <div :style="{ background: '#fff', textAlign: 'center' }">
                    <router-view></router-view>
                </div>
            </a-layout-content>
            <a-layout-footer :style="{ textAlign: 'center' }">
                666Tec ©2020 Created by 上海三个六网络科技有限公司
            </a-layout-footer>
        </a-layout>
    </a-layout>
</template>

<script>
import 'ant-design-vue/dist/antd.css';

export default {
    name: "Home",
    data() {
        return {
            collapsed: false,
        };
    },
}
</script>

<style scoped>
body {
    /*overflow-y: hidden !important;*/
}

.logo {
    height: 32px;
    /*background: rgba(255, 255, 255, 0.2);*/
    margin: 16px 0 0 0;
    border-bottom: 1px solid #1890ff;
    padding-bottom: 40px;
}

.logo-h {
    color: white;
    font-size: 1.2em;
    text-align: center;
}
.trigger {
    font-size: 18px;
    line-height: 64px;
    padding: 0 24px;
    cursor: pointer;
    transition: color 0.3s;
}
.trigger:hover {
    color: #1890ff;
}
/*.nav-text a {*/
/*    color: rgba(255, 255, 255, 0.65)*/
/*}*/
</style>